import { render, staticRenderFns } from "./Desktops.vue?vue&type=template&id=45180f10&"
import script from "./Desktops.vue?vue&type=script&lang=js&"
export * from "./Desktops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports